module.exports = __webpack_public_path__ + "static/water_glacier4-98cf2989b4cf33823779900a3b2d198f.jpg";